"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCalendar = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const date_fns_1 = require("date-fns");
const react_hook_breakpoints_1 = require("react-hook-breakpoints");
const locale_1 = require("./locale");
const useCalendar_1 = require("./useCalendar");
const breakpoints_1 = require("../utils/breakpoints");
const SmCalendarFooter_1 = require("./SmCalendarFooter");
const SmCalendarHeader_1 = require("./SmCalendarHeader");
const SmCalendarDay_1 = require("./SmCalendarDay");
const SmCalendar = (_a) => {
    var { value, className, components, multiCalendarComponents, showDaysOutsideCurrentMonth = false, loading = false, disableFuture = false, disablePast = false, highlightToday = true, multiCalendar = false, disableWeekends = false, disabledDates, disableHolidays = false, showHolidays = true, maxDate = (0, date_fns_1.addDays)(new Date(), 330), minDate = (0, date_fns_1.subDays)(new Date(), 330), locale = locale_1.ptBR, onSelectDate, onMonthChange } = _a, props = __rest(_a, ["value", "className", "components", "multiCalendarComponents", "showDaysOutsideCurrentMonth", "loading", "disableFuture", "disablePast", "highlightToday", "multiCalendar", "disableWeekends", "disabledDates", "disableHolidays", "showHolidays", "maxDate", "minDate", "locale", "onSelectDate", "onMonthChange"]);
    const { selectedValue, currentMonthView, calendarComponents } = (0, useCalendar_1.useCalendarElements)({
        value,
        components,
        multiCalendarComponents,
        showDaysOutsideCurrentMonth,
        loading,
        disableFuture,
        disablePast,
        highlightToday,
        multiCalendar,
        disableWeekends,
        disabledDates,
        disableHolidays,
        showHolidays,
        maxDate,
        minDate,
        locale,
        onSelectDate,
        onMonthChange,
    });
    const calendarClassnames = (0, classnames_1.default)('c-calendar', { '-multiCalendar': multiCalendar, '-loading': loading }, className);
    const headerElement = react_1.default.useMemo(() => {
        return multiCalendar ? (react_1.default.createElement(react_hook_breakpoints_1.MatchMediaBreakpoints, { breakpoints: breakpoints_1.breakpoints },
            react_1.default.createElement(react_hook_breakpoints_1.MatchBreakpoint, { is: "lg" }, calendarComponents.multiCalendarHeaderElement(currentMonthView, 'previous')),
            react_1.default.createElement(react_hook_breakpoints_1.MatchBreakpoint, { min: "xs", max: "md" }, calendarComponents.headerElement(currentMonthView)))) : (calendarComponents.headerElement(currentMonthView));
    }, [
        selectedValue,
        currentMonthView,
        multiCalendar,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
    ]);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: calendarClassnames }), loading ? (calendarComponents.loadingElement) : (react_1.default.createElement(react_1.default.Fragment, null,
        calendarComponents.calendarElement({
            header: () => headerElement,
            footer: () => calendarComponents.footerElement(currentMonthView),
        }),
        react_1.default.createElement(react_hook_breakpoints_1.MatchMediaBreakpoints, { breakpoints: breakpoints_1.breakpoints },
            react_1.default.createElement(react_hook_breakpoints_1.MatchBreakpoint, { is: "lg" }, calendarComponents.multiCalendarElement(1)))))));
};
exports.SmCalendar = SmCalendar;
exports.SmCalendar.Footer = SmCalendarFooter_1.SmCalendarFooter;
exports.SmCalendar.Header = SmCalendarHeader_1.SmCalendarHeader;
exports.SmCalendar.Day = SmCalendarDay_1.SmCalendarDay;
//# sourceMappingURL=index.js.map